export class MenuClaims {
  static TYPE = 'Menu';
  static PERMISSIONS = {
    'PORT CALL': false,
    USERS: false,
    SHIPS: false,
    ORGANIZATIONS: false,
    LOCATIONS: false
  };
  static PORT_CALL = 'PORT CALL';
  static USERS = 'USERS';
  static SHIPS = 'SHIPS';
  static ORGANIZATIONS = 'ORGANIZATIONS';
  static LOCATIONS = 'LOCATIONS';
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/menu-claims.ts